export function leave(el: any) {
    el.classList.contains('vuw-slide-leave') ? el.style.right = `30px` : el.style.left = `30px`
}